@if (isLoading()) {
  <div class="sidebar-heartbeat-overlay-container d-flex flex-column">
    <div class="spinner-wrapper m-auto p-sm">
      <cw-spinner />
    </div>
  </div>
}
